<template>
  <div class="container" id="display">
    <div class="row" v-if="inServiceTickets.length !== 0">
      <div class="split left" :style="'background-color: #fff;'">
        <!-- <iframe
          id="video"
          :src="video_link"
          allow="autoplay"
          allowscriptaccess="always"
          class="yt_player_iframe"
          frameborder="0"
          height="65%"
          width="100%"
        >
        </iframe> -->
        <div
          v-if="video_link !== ''"
          style="
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
          "
        >
          <video
            id="my-video"
            height="100%"
            autoplay
            loop
            :poster="placeholderVideo"
          >
            <source :src="video_link" type="video/webm" />
            Your browser does not support the video tag.
          </video>
        </div>
        <div v-else>
          <img
            :src="'data:image/jpeg;base64,' + photo"
            class="image-pub"
            height="100%"
          />
        </div>
      </div>
      <!-- <div v-else-if="video_link == ''" class="split left" :style="'background-color: #fff'">
        <img
          :src="'data:image/jpeg;base64,' + photo"
          class="image-pub"
          height="100%"
        />
      </div> -->
      <div class="split right">
        <WaitingList
          id="wait-listing"
          :key="ComponentKey"
          :tickets="inServiceTickets"
          :nextTickets="nextTickets"
          :queues_ids="queues_ids"
        ></WaitingList>
      </div>
    </div>
    <div v-else style="display: flex; justify-content: center">
      <div
        v-if="video_link !== ''"
        style="height: 95vh; background-color: #fff"
      >
        <video height="100%" autoplay loop :poster="placeholderVideo">
          <source :src="video_link" type="video/webm" />
          Your browser does not support the video tag.
        </video>
      </div>
      <div v-else>
        <img :src="'data:image/jpeg;base64,' + photo" class="image-pub" />
      </div>
    </div>
    <div id="status"></div>
    <div :style="'background-color:' + config.color + ' ;'" class="footer row">
      <!--
<div style="background-color:#fff;" class="footer row" > -->
      <!--<section>
    <div class="slider" :style="'color:'+config.colorText">
      <section class="news-message">
        <img class="logo" height="15vh" src=@/assets/images/logo/logo-white.png>
        <p class="powered-by-text">powered by</p>
        <p class="powered-by-text">Hello World Hello World</p>
        <p class="powered-by-text">powered by</p>
        <p class="powered-by-text">Hello World Hello World</p>
        <p class="powered-by-text">powered by</p>
        <p class="powered-by-text">Hello World Hello World</p>

        <p class="powered-by-text">Hello World Hello World</p>
        <img class="logo" height="15vh" src=@/assets/images/logo/logo-white.png>
      </section>
    </div>
  </section> -->
      <p class="powered-by-text" :style="'color:' + config.colorText">
        powered by
      </p>
      <img
        class="logo"
        height="12vh"
        src="@/assets/images/logo/logo_white.png"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { displayService } from "../../_services";
import { notificationPlay } from "../../_helpers";
import LongPress from "vue-directive-long-press";
import $ from "jquery";
import Header from "@/views/components/Header";
import WaitingList from "@/views/components/Waiting";
import html2canvas from "html2canvas";
//import WaitingList from "@/views/components/WaitingList";

export default {
  name: "DisplayScreen.vue",
  components: { WaitingList, Header },
  data: () => ({
    placeholderVideo: "",
    photo: "",
    logo: "",
    queues: [],
    updatedQueues: [],
    selectedQueue: null,
    intvId: null,
    time: "00:00:00",
    date: "",
    week: ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"],
    eventMatchers: {
      HTMLEvents:
        /^(?:load|unload|abort|error|select|change|submit|reset|focus|blur|resize|scroll)$/,
      MouseEvents: /^(?:click|dblclick|mouse(?:down|up|over|move|out))$/,
    },
    defaultOptions: {
      pointerX: 0,
      pointerY: 0,
      button: 0,
      ctrlKey: false,
      altKey: false,
      shiftKey: false,
      metaKey: false,
      bubbles: true,
      cancelable: true,
    },
    test: "",
    playerVars: {
      autoplay: 1,
    },
    video_link: "",
    ticket: {},
    spokenLanguage: "",
    voiceCounter: "Guichet",
    voiceNumber: "Numéro",
    config: {
      voiceNumber: "",
      voiceCounter: "",
    },
    voice_is_playing: false,
    voices_to_play: [],

    boucled_queues: 0,
    total_queues: 999,

    ComponentKey: 0,
    queues_ids: "",
    inServiceTickets: [],
    nextTickets: [],
    playNotification: true,
    error_request: false,
    _pingInterval: null,
  }),
  directives: {
    "long-press": LongPress,
  },
  methods: {
    ...mapActions("Display", ["refresh"], "logout"),
    showLoading() {
      this.$vs.loading({
        container: "#checkin-box",
        scale: 0.6,
      });
    },
    hideLoading() {
      this.$vs.loading.close("#checkin-box > .con-vs-loading");
    },
    getDisplayQueues() {
      this.queues_ids = JSON.parse(
        this.kiosk_info.display.config
      ).queues.toString();
      let queues = JSON.parse(this.kiosk_info.display.config)
        .queues.toString()
        .split(",");
      this.total_queues = queues.length;
      // console.log("type queue id: " + typeof this.queues_ids);
      displayService.getInServiceTickets(this.queues_ids).then(
        function (data) {
          this.inServiceTickets = data.tickets.map((obj) => {
            if (
              obj.counter_id == "-1" ||
              !obj.counter_name ||
              obj.public_identifier.length > obj.counter_name.length
            ) {
              obj.sizeLength = obj.public_identifier.length;
            } else {
              obj.sizeLength = obj.counter_name.length;
            }
            if (obj.sizeLength > 11) {
              obj.sizeLength = 10;
            }
            return obj;
          });
          this.ComponentKey++;
        }.bind(this)
      );

      // console.log("display subscribed: " + this.kiosk_info.display.id);

      this.$pusher
        .channel("private-display-" + this.kiosk_info.display.id)
        .listen(
          ".ticket-call",
          function (data) {
            // console.log("_________________");
            // console.log(data);
            this.ticket = data;

            this.nextTickets = data.waiting_list;

            let text = "";
            if (
              localStorage.getItem("number") &&
              localStorage.getItem("counter")
            ) {
              text =
                JSON.parse(localStorage.getItem("number")).voice +
                data.num_voice +
                JSON.parse(localStorage.getItem("counter")).voice +
                data.counter_voice;
            }

            this.voices_to_play.push(text);

            if (data.in_service) {
              // console.log("data.in_service2", data.in_service);
              this.inServiceTickets = data.in_service.map((obj) => {
                if (
                  obj.counter_id == "-1" ||
                  !obj.counter_name ||
                  obj.public_identifier.length > obj.counter_name.length
                ) {
                  obj.sizeLength = obj.public_identifier.length;
                } else {
                  obj.sizeLength = obj.counter_name.length;
                }
                if (obj.sizeLength > 11) {
                  obj.sizeLength = 10;
                }
                return obj;
              });
              // console.log("this.inServiceTicketsF", this.inServiceTickets);
            }
          }.bind(this)
        )
        .listen(
          ".ticket-recall",
          function (data) {
            // console.log("_________________");
            // console.log(data);
            this.ticket = data;

            this.nextTickets = data.waiting_list;

            let text = "";
            if (
              localStorage.getItem("number") &&
              localStorage.getItem("counter")
            ) {
              text =
                JSON.parse(localStorage.getItem("number")).voice +
                data.num_voice +
                JSON.parse(localStorage.getItem("counter")).voice +
                data.counter_voice;
            }

            this.voices_to_play.push(text);

            if (data.in_service) {
              // console.log("data.in_service2", data.in_service);
              this.inServiceTickets = data.in_service.map((obj) => {
                if (
                  obj.counter_id == "-1" ||
                  !obj.counter_name ||
                  obj.public_identifier.length > obj.counter_name.length
                ) {
                  obj.sizeLength = obj.public_identifier.length;
                } else {
                  obj.sizeLength = obj.counter_name.length;
                }
                if (obj.sizeLength > 11) {
                  obj.sizeLength = 10;
                }
                return obj;
              });
              // console.log("this.inServiceTicketsF", this.inServiceTickets);
            }
          }.bind(this)
        );
    },
    updateTime() {
      var cd = new Date("2022-01-01 " + this.kiosk_info.display.time);
      this.time =
        this.zeroPadding(cd.getHours(), 2) +
        ":" +
        this.zeroPadding(cd.getMinutes(), 2);
      //this.date = this.zeroPadding(cd.getFullYear(), 4) + '-' + this.zeroPadding(cd.getMonth()+1, 2) + '-' + this.zeroPadding(cd.getDate(), 2);
    },
    zeroPadding(num, digit) {
      var zero = "";
      for (var i = 0; i < digit; i++) {
        zero += "0";
      }
      return (zero + num).slice(-digit);
    },
    playVideo() {
      $(".yt_player_iframe").each(function () {
        this.contentWindow.postMessage(
          '{"event":"command","func":"playVideo","args":""}',
          "*"
        );
      });
    },
    logout() {
      localStorage.removeItem("display");
      localStorage.removeItem("number");
      localStorage.removeItem("counter");
      window.location.href = "/login";
    },
    ping() {
      try {
        html2canvas(document.body, {
          scale: 1, // scale canvas to 2x
        }).then(function (canvas) {
          canvas.toBlob(
            function (blob) {
              let form = new FormData();
              var reader = new FileReader();
              reader.readAsDataURL(blob);
              reader.onloadend = function () {
                form.append("screenshot", reader.result);
                displayService
                  .ping(form)
                  .then(function () {}.bind(this))
                  .catch(
                    function (err) {
                      console.log(err);
                    }.bind(this)
                  );
              };
            },
            "image/jpeg",
            0.02
          ); // compress with JPEG and quality of 40%
        });
      } catch (err) {
        console.log(err);
      }
    },
    convertTextToVoice(text, language, type) {
      let numberObject = JSON.parse(localStorage.getItem("number"));
      let counterObject = JSON.parse(localStorage.getItem("counter"));
      if (numberObject && counterObject) {
        if (
          JSON.parse(this.kiosk_info.display.config).locale.toString() ==
          counterObject.language
        ) {
          return 0;
        }
      }
      let body = {
        text: text,
        language: language,
      };
      displayService
        .getVoiceTelling(body)
        .then(function (response) {
          localStorage.setItem(
            type,
            JSON.stringify({
              voice: response["audio-content"],
              language: language,
            })
          );
        })
        .catch(function (err) {
          console.log(err);
        });
    },
  },
  computed: {
    ...mapState({
      kiosk_info: (state) => state.Display.display,
    }),
  },
  created() {},
  mounted() {
    let sound = require("../../assets/sounds/slow-spring-board.mp3");
    // console.log("Config: " + this.config.colorSecondary);
    // console.log(
    //   "Video Link: " + JSON.parse(this.kiosk_info.display.config).video_link
    // );
    // console.log("business: " + this.kiosk_info.business.photo);
    this.placeholderVideo = this.kiosk_info.business.photo;
    if (!JSON.parse(this.kiosk_info.display.config).video_link) {
      this.video_link = "";
      // console.log("Video Link: " + this.video_link);
    } else if (JSON.parse(this.kiosk_info.display.config).video_link) {
      this.video_link = JSON.parse(this.kiosk_info.display.config).video_link;
      // console.log("Video Link: " + this.video_link);
    }
    const self = this;
    this.photo = this.kiosk_info.display.background;
    //console.log("PHOTO: "+this.photo);
    this.logo = this.kiosk_info.business.photo;
    this.businessName = this.kiosk_info.business.name;
    setInterval(function () {
      if (!self.voice_is_playing) {
        if (self.voices_to_play.length > 0) {
          self.voice_is_playing = true;
          // notification doesn't play if there is an error

          var audio = new Audio(sound);
          audio.play();
          audio.addEventListener("ended", function () {
            var snd = new Audio(
              "data:audio/wav;base64," + self.voices_to_play[0]
            );
            try {
              snd.play();

              snd.addEventListener("ended", function () {
                //console.log("ended");
                self.voice_is_playing = false;
              });
            } catch (err) {
              console.log(err);
            }
            self.voices_to_play.splice(0, 1);
          });
        }
      }
    }, 500);
    this.config = JSON.parse(this.kiosk_info.display.config);

    switch (JSON.parse(this.kiosk_info.display.config).locale.toString()) {
      case "en":
        this.spokenLanguage = "en";
        this.voiceNumber = "Number";
        this.voiceCounter = "Counter";
        break;
      case "fr":
        this.spokenLanguage = "fr";
        this.voiceNumber = "Numéro";
        this.voiceCounter = "Guichet";
        break;
      case "es":
        this.spokenLanguage = "es";
        this.voiceNumber = "Numéro";
        this.voiceCounter = "Guichet";
        break;
      case "pt":
        this.spokenLanguage = "pt";
        this.voiceNumber = "Numéro";
        this.voiceCounter = "Guichet";
        break;
      case "de":
        this.spokenLanguage = "de";
        this.voiceNumber = "Numéro";
        this.voiceCounter = "Guichet";
        break;
      case "ru":
        this.spokenLanguage = "ru   ";
        this.voiceNumber = "Numéro";
        this.voiceCounter = "Guichet";
        break;
      case "ar":
        this.spokenLanguage = "ar";
        this.voiceNumber = "رَقِمْ";
        this.voiceCounter = "شُبّاكْهْ";
        break;
      default:
        this.spokenLanguage = "fr";
    }
    // take customized counter & number text if exists
    if(this.config.voiceCounter) {
      this.voiceCounter = this.config.voiceCounter;
    }
    if(this.config.voiceNumber) {
      this.voiceNumber = this.config.voiceNumber;
    }
    // get base 64 of counter & number text
    this.convertTextToVoice(this.voiceNumber, this.spokenLanguage, "number");
    this.convertTextToVoice(this.voiceCounter, this.spokenLanguage, "counter");

    this.$loadScript(
      "https://code.responsivevoice.org/responsivevoice.js?key=tgQI6QQn"
    );
    var updateScreenCallback;
    updateScreenCallback = function () {
      location.reload(true);
    };

    this.getDisplayQueues();
    // eslint-disable-next-line no-console
    // console.log("queuesXX: " + this.queues_ids);

    // console.log("Video Link: " + JSON.parse(this.kiosk_info.display.config));
    if (!JSON.parse(this.kiosk_info.display.config).video_link) {
      this.video_link = "";
      // console.log("Video Link: " + this.video_link);
    } else if (JSON.parse(this.kiosk_info.display.config).video_link) {
      this.video_link = JSON.parse(this.kiosk_info.display.config).video_link;
      // console.log("Video Link: " + this.video_link);
    }
    setInterval(this.updateTime, 1000);
    this.updateTime();

    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState == "hidden") {
        $(".yt_player_iframe").each(function () {
          this.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            "*"
          );
        });
      } else if (document.visibilityState == "visible") {
        $(".yt_player_iframe").each(function () {
          this.contentWindow.postMessage(
            '{"event":"command","func":"playVideo","args":""}',
            "*"
          );
        });
      }
    });
    // ping to server
    if (this.$pingInterval) {
      this._pingInterval = setInterval(this.ping, this.$pingInterval);
    }

    // refresh display with teller
    this.$pusher
      .channel("private-display-" + this.kiosk_info.display.id)
      .listen(
        ".display-refresh",
        function (data) {
          this.refresh()
            .then(function () {})
            .catch(function (err) {
              console.log(err);
            })
            .finally(
              function () {
                console.log(this.$route.name);
                console.log(this.$route.name == "Maintenance");
                // close channel before leaving so duplicates don't happen
                this.$pusher.leaveChannel(
                  "private-display-" + this.kiosk_info.display.id
                );
                // closing setInterval for same reason
                clearInterval(this._pingInterval);
                if (this.$route.name == "Maintenance") {
                  this.$router.push("/play");
                } else {
                  this.$router.go();
                }
              }.bind(this)
            );
        }.bind(this)
      );

    // auto logout display
    this.$pusher
      .channel("private-display-" + this.kiosk_info.display.id)
      .listen(
        ".display-logout",
        function (data) {
          this.logout().then(
            function () {
              clearInterval(this._pingInterval);
              this.$router.push("/login");
            }.bind(this)
          );
        }.bind(this)
      );

    if (this.kiosk_info && this.kiosk_info.display.maintenance) {
      this.$router.push("/maintenance");
    }

    // maintenance change
    this.$pusher
      .channel("private-display-" + this.kiosk_info.display.id)
      .listen(
        ".maintenance-change",
        function (data) {
          this.refresh()
            .then(function () {})
            .catch(function (err) {
              console.log(err);
            })
            .finally(
              function () {
                console.log(this.$route.name);
                console.log(this.$route.name == "Maintenance");
                // close channel before leaving so duplicates don't happen
                this.$pusher.leaveChannel(
                  "private-display-" + this.kiosk_info.display.id
                );
                // closing setInterval for same reason
                clearInterval(this._pingInterval);
                if (this.$route.name == "Maintenance") {
                  this.$router.push("/play");
                } else {
                  this.$router.go();
                }
              }.bind(this)
            );
        }.bind(this)
      );
  },
  beforeDestroy() {
    clearInterval(this.intvId);
    clearInterval(this._pingInterval);
  },
};
</script>
<style lang="scss" scoped>
.image-pub {
  object-fit: contain;
  max-height: 100%;
  max-width: 100%;
}
.container {
  min-height: 100vh;
  min-width: 100vw;
  background-color: #ffffff;
  /* Split the screen in half */
  .split {
    width: 50%;
    height: 95vh;
    z-index: 1;
    top: 0;
    overflow-x: hidden;
    overflow-y: hidden;
    justify-content: center;
    align-items: center;
  }

  /* Control the left side */
  .left {
    justify-content: center;
    align-items: center;
    width: 66%;
    left: 0;
    //  background-color: #02A3DE;
  }

  /* Control the right side */
  .right {
    // background-color: #02A3DE;
    width: 34%;
    right: 0;
  }
}

.footer {
  align-items: center;
  min-width: 100vw;
  height: 5vh;
  justify-content: center;
  .powered-by-text {
    margin: 4px;
    //letter-spacing: 2px;
    font-size: 0.5rem;
    font-weight: bold;
    text-transform: uppercase;
  }

  .logo {
    margin: 4px;
    // opacity: 90%;
  }
}

.business-info {
  margin-left: 32px;

  .business-logo {
    object-fit: scale-down;
  }

  .business-name {
    margin: 16px;
    font-size: 2em;
    color: #fff8ec;
  }
}
</style>
